/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { addDays, addHours, addSeconds } from "date-fns";
import { DatePicker } from "@/app/(components)/Basic/DatePicker";
import { FormDropdownInput } from "@/app/(components)/Basic/FormDropdown";
import { TimeUnit } from "@/shared/constants";
import { useFormikContext } from "formik";
import {
  DropdownWithDatePickerContext,
  DropdownWithDatePickerOption,
} from "./types";

interface Props {
  options: DropdownWithDatePickerOption[];
  dropdownName: string;
  dateName: string;
  disabled: boolean;
  label?: string;
}

const FormDropdownWithDatePicker = ({
  options,
  dropdownName,
  dateName,
  disabled,
  label,
}: Props) => {
  const { values, setFieldValue } =
    useFormikContext<DropdownWithDatePickerContext>();

  const optionTimeUnit = options.find(
    (option) => option.value === values[dropdownName],
  )?.timeUnit;

  useEffect(() => {
    if (!optionTimeUnit) {
      setFieldValue(dateName, values[dateName]);
      return;
    }

    let date: Date;

    if (optionTimeUnit === TimeUnit.DAYS)
      date = addDays(new Date(), +values[dropdownName]);

    if (optionTimeUnit === TimeUnit.HOURS)
      date = addHours(new Date(), +values[dropdownName]);

    if (optionTimeUnit === TimeUnit.SECONDS)
      date = addSeconds(new Date(), +values[dropdownName]);

    setFieldValue(dateName, date!);
  }, [values[dropdownName]]);

  return (
    <div className="flex gap-1 items-end w-full">
      <FormDropdownInput
        options={options.map((option) => ({
          label: option.label,
          value: option.value,
        }))}
        name={dropdownName}
        disabled={disabled}
        containerClassName="w-full"
        wrapperClassName="mb-6"
        className="w-full text-primary text-body-3 h-[40px] py-0 bg-transparent focus:endemic:border-green"
        childrenClassName="font-light overflow-y-auto h-[200px]"
        label={label}
        borderClassName="endemic:border-invert"
        labelClassName="endemic:text-invert"
      />

      <div className="w-full">
        <DatePicker
          disabled={disabled}
          name={dateName}
          showTimeSelect={true}
          calendarClassName="w-full"
          handleOnChange={() => setFieldValue(dropdownName, "custom")}
        />
      </div>
    </div>
  );
};

export default FormDropdownWithDatePicker;
